import { Button, Modal, Table } from 'antd'
import { ColumnProps } from 'antd/lib/table'
import React from 'react'
import isDefined from '../../helpers/isDefined'
import { resultColumns } from '../../shared/columns'

type PlayerWithScore = { name: string; totalScore: number }

type StartModalProps = {
  round: number
  flightNumber: number
  playersWithScore: PlayerWithScore[]
  hide(): void
}

const finishModalColumns: Array<ColumnProps<PlayerWithScore>> = [
  {
    title: 'Name',
    dataIndex: 'name',
  },
  resultColumns.sum,
]

const FinishModal: React.FunctionComponent<StartModalProps> = ({
  round,
  flightNumber,
  playersWithScore,
  hide,
}) => (
  <Modal
    className="MobileResults-FinishModal"
    visible
    title={`Round ${round} Finished`}
    onCancel={hide}
    footer={
      <Button key="close" onClick={hide}>
        Back to Results
      </Button>
    }>
    <Table
      rowKey="name"
      bordered={false}
      pagination={false}
      showHeader={false}
      columns={finishModalColumns}
      dataSource={playersWithScore.filter(isDefined)}
    />
  </Modal>
)

export default FinishModal



// WEBPACK FOOTER //
// ./src/components/mobile/FinishModal.tsx